module.exports = __webpack_public_path__ + "static/media/1.2 Wartung Servatius Klimatechnik klein.76d81409.jpg";